import { atom } from 'recoil'
import { language } from '../types'

export const langAtom = atom<language>({
  key: 'langState',
  default: 'JA',
})